import { teamHasDialler } from "./usersAndGroups";

const allLiveFeedActivityOptions = [
  { value: "opens", label: "Opens", icon: "opens", show: true },
  { value: "clicks", label: "Clicks", icon: "clicks", show: true },
  { value: "replies", label: "Replies", icon: "replies", show: true },
  {
    value: "voicemails",
    label: "Voicemails",
    icon: "voicemails",
    show: teamHasDialler,
  },
  {
    value: "hotlist",
    label: "Hotlist",
    icon: "hotlist",
    show: true,
  },
];

export const liveFeedActivityOptions = allLiveFeedActivityOptions.filter(
  (option) => option.show,
);

export const liveFeedTabOptions = [
  { value: "liveFeed", label: "Live Feed" },
  { value: "hotlist", label: "Hotlist" },
];
